query materialsFiltered($input: MaterialsFilteredInput!) {
  materials: materialsFiltered(input: $input) {
    id
    type
    purpose
    mode
    campaignId
    landingpageId
    files {
      file {
        id
        url
        cdnUrl(named: true)
      }
      previewFile {
        id
        url
        cdnUrl
      }
    }
    version
    hasFile
    displayName
    createdAt
    updatedAt
  }
}
